import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Selected_Index } from '../../../../../constants/external-constants';
import ButtonIcon from '../../../../button';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';
import InvoiceFormContainer from './invoice-form.container';
import LineItems from '../line-items/line-items.component';
import InvoiceCommentsComponent from '../invoice-comments/invoice-comments-component';
import AuditLayout from '../audit/invoice-audit-layout.component';

import { invoiceDetailsAction } from '../../../../../store/external/invoice/invoice/invoice-details.reducer';
import InvoiceHistoryComponent from '../invoice-history/invoice-history-component';
class InvoiceDetailsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Line Items",
                    "hidden": false,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "Audit",
                    "hidden": false,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Three,
                    "label": "Cost Allocation",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Four,
                    "label": "Comments",
                    "hidden": false,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Five,
                    "label": "History",
                    "hidden": false,
                    "disable": false
                }
            ],
        };
    }

    FilterIndex = (tabIndex) => {
        this.setState({ selectedIndex: tabIndex });
        this.renderTabContent(tabIndex)
    }

    handlecloseForm = () => {
        const { handleClose, resetInvoiceDetailsForm } = this.props;      
        resetInvoiceDetailsForm();
        handleClose();
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {
        const { disputeDetailsId } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && disputeDetailsId > 0) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {       
        const { listTab, selectedIndex } = this.state;
        const { invoiceDetailsId, invoiceId, roles } = this.props;
       
        return (
            <div className="layout-container">
                <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} />
                    : null}
                
                {selectedIndex === Selected_Index.i_Zero && <InvoiceFormContainer invoiceDetailsId={invoiceDetailsId ? invoiceDetailsId : invoiceId} roles={roles} {...roles} handlecloseForm={this.handlecloseForm}/>}
                {selectedIndex === Selected_Index.i_One && <LineItems invoiceDetailsId={invoiceDetailsId ? invoiceDetailsId : invoiceId} invoiceNumber={this.props.invoiceNumber} roles={roles} {...roles} />}
                {selectedIndex === Selected_Index.i_Four && <InvoiceCommentsComponent invoiceDetailsId={invoiceDetailsId ? invoiceDetailsId : invoiceId} roles={roles} {...roles} />}
                {selectedIndex === Selected_Index.i_Five && <InvoiceHistoryComponent invoiceDetailsId={invoiceDetailsId ? invoiceDetailsId : invoiceId} roles={roles} {...roles} />}
                {selectedIndex === Selected_Index.i_Two && <AuditLayout invoiceDetailsId={invoiceDetailsId ? invoiceDetailsId : invoiceId} roles={roles} {...roles} />}

            </div>
        );
    }
}

export default connect(
    state => {
        return {};
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceDetailsAction),
        dispatch
    )
)(InvoiceDetailsView)